import React, { useContext } from 'react';
import { ActionMeta, AsyncSelect, ValueType } from '@atlaskit/select';
import { DTOGroupSearchResultItem, ErrorOrPayload, GET_GROUP_PICKER_QUERY } from '../../generated-common';
import { GlobalContext } from '../../shared-components/common/GlobalContext';
import { SelectValueLabel } from './UserWithAvatar';

export const CCGroupPicker = ({
  onGroupPicked,
  alreadyAssignedGroupIds,
  isMutating,
}: {
  onGroupPicked: (groupId: string, groupName: string) => void;
  alreadyAssignedGroupIds: string[];
  isMutating: boolean;
}) => {
  const { t, handleRestError, invoke } = useContext(GlobalContext);
  return (
    <AsyncSelect
      formatOptionLabel={(option: SelectValueLabel, { context }: { context: any }) => {
        if (context === 'menu') {
          return <>{option.label}</>;
        }
        return option.label;
      }}
      loadOptions={(searchText: any, callback: Function) => {
        invoke(GET_GROUP_PICKER_QUERY, { query: searchText }).then((errorOrPayload: null | ErrorOrPayload<DTOGroupSearchResultItem[]>) => {
          handleRestError(errorOrPayload, GET_GROUP_PICKER_QUERY);
          const groupsToDisplay: any[] = [];
          if (errorOrPayload && errorOrPayload.payload) {
            for (const foundUser of errorOrPayload.payload) {
              groupsToDisplay.push({
                value: foundUser.groupId,
                label: foundUser.groupName,
              });
            }
          }
          callback(groupsToDisplay);
        });
      }}
      isDisabled={isMutating}
      isClearable={false}
      isSearchable={true}
      isOptionDisabled={(_option: SelectValueLabel) => {
        return alreadyAssignedGroupIds.includes(_option.value);
      }}
      value={null}
      placeholder={t('editPermissionsPage.placeholders.groupPermissions')}
      noOptionsMessage={() => t('editPermissionsPage.placeholders.typeToSeeGroups')}
      onChange={(value: ValueType<SelectValueLabel, false>, action: ActionMeta<SelectValueLabel>) => {
        if (value && value.value) {
          onGroupPicked(value.value, value.label);
        }
      }}
    />
  );
};
